export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'a7ef8c679emshf599c08c6b6cea9p1755b3jsn0469e37b8b89',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "ee7e225dd0e1da3a51ea402a580a3a79";
